// LOCAL
//export const API_URL = 'http://localhost:3001';
//export const FRONTEND_URL  = 'http://localhost:3000';
//export const BILLDESK_URL = 'http://34.93.35.227:8086';
//export const KEYCLOCK_REALM = 'CET_DEV';
//export const KEYCLOCK_CLIENT = 'CET_DEV';
//export const KEYCLOCK_USERNAME = 'admin';
//export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
//export const KEYCLOAK_REDIRECT_URI = 'http://localhost:3000/mhcet/home';
//export const CAP_REGISTRATION_URL = 'http://localhost:5173/mhcet';


// NEW UAT
export const API_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
export const FRONTEND_URL  = 'https://mhcet-reg-uat.hubblehox.ai';
export const BILLDESK_URL = 'https://mhcet-reg-uat.hubblehox.ai/api';
//export const KEYCLOCK_REALM = 'CET_UAT_NEW';
//export const KEYCLOCK_CLIENT = 'CET_UAT_NEW';
//export const KEYCLOCK_USERNAME = 'admin';
//export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
//export const KEYCLOAK_REDIRECT_URI = 'https://mhcet-reg-uat.hubblehox.ai/mhcet/home';
export const CAP_REGISTRATION_URL = 'https://mhcet-cap-student-dev.hubblehox.ai/';

export const KEYCLOCK_REALM = 'mh-cet-stage-2026';
export const KEYCLOCK_CLIENT = 'central-launchpad-stage';
export const KEYCLOCK_USERNAME = 'admin';
export const KEYCLOCK_URL = 'https://mhcet-keycloak-stag-2026.hubblehox.ai';
export const KEYCLOAK_REDIRECT_URI = 'https://mhcet-cap-student-dev.hubblehox.ai';

// NEW DEV
// export const API_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
// export const FRONTEND_URL  = 'https://mhcet-reg-dev.hubblehox.ai';
// export const BILLDESK_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
// export const KEYCLOCK_REALM = 'CET_DEV_NEW';
// export const KEYCLOCK_CLIENT = 'CET_DEV_NEW';
// export const KEYCLOCK_USERNAME = 'admin';
// export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
// export const KEYCLOAK_REDIRECT_URI = 'https://mhcet-reg-dev.hubblehox.ai/mhcet/home';


// TEST
// export const API_URL = 'https://mhcet-test.praathee.in/api';
// export const FRONTEND_URL  = 'https://mhcet-test.praathee.in';
// export const BILLDESK_URL = 'https://mhcet-test.praathee.in/api';
// export const KEYCLOCK_REALM = 'CET_DEV';
// export const KEYCLOCK_CLIENT = 'CET_DEV';
// export const KEYCLOCK_USERNAME = 'admin';
// export const KEYCLOCK_URL = 'https://auth.mhcet-reg-dev.hubblehox.ai';
// export const KEYCLOAK_REDIRECT_URI = 'https://mhcet-test.praathee.in/mhcet/home';
// export const CAP_REGISTRATION_URL = ' https://mhcet-cap-student.praathee.in';
   
//COMMON
export const AES_KEY = "0a1a57889030315bd571c8f72ba1c3b2ea811e2de93b9e34a4e2e3e88cba2c7a";
export const AES_IV = "76c2b153ff33ba05d5cfaa1ece032868";
